import React, { useEffect } from "react";
import { Card, List, Avatar, Badge, Typography } from "antd";
import styled from "styled-components";
import { CALL_API } from "common/API";
import { useSelector } from "react-redux";
import { getClientid, getUserInfo } from "redux/selectors";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const { Text, Title } = Typography;

const Wrapper = styled(Card)`
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  border-radius: 5px;
  border: none;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .view-all {
    color: #1d4ed8;
    cursor: pointer;
    font-weight: 500;
  }
`;

const ListWrapper = styled.div`
  height: 200px;
  overflow-y: auto;
  padding-right: 4px;

  /* scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #e5e7eb;
    border-radius: 4px;
  }
`;

const AnnouncementItem = styled(List.Item)`
  padding: 5px 0px;
  border-radius: 10px;
  cursor: pointer;
  border-bottom: none !important;

  &:hover {
    background: #f9fafb;
  }

  &.active {
    background: #f3f4f6;
  }

  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .time {
    color: #6b7280;
    font-size: 13px;
    padding-right: 10px;
  }
`;

const UpcommingHolidayLists = () => {
  const { t } = useTranslation();
  const ClientId = useSelector(getClientid);
  const userInfo = useSelector(getUserInfo);
  const [holidayList, setHolidayList] = React.useState([]);
  console.log("holidayList", holidayList);

  const getHolidayList = async () => {
    const response = await CALL_API(`holiday-list/${ClientId}`, "post", {
      start_date: dayjs().format("YYYY-MM-DD"),
      end_date: dayjs().endOf("year").format("YYYY-MM-DD"),
    });
    console.log("response2-->", response, userInfo);
    setHolidayList(
      response?.filter((item) =>
        item?.location_id?.includes(userInfo?.baseLocationId)
      ) || []
    );
  };

  useEffect(() => {
    getHolidayList();
  }, []);

  return (
    <Wrapper>
      {/* Header */}
      <div className="header">
        <Title level={5}>{t("Upcoming Holidays")}</Title>
      </div>

      {/* List */}
      <ListWrapper>
        <List
          itemLayout="horizontal"
          dataSource={holidayList}
          renderItem={(item) => (
            <AnnouncementItem className={item.active ? "active" : ""}>
              <List.Item.Meta
                title={
                  <div className="content">
                    <Text>{item.holiday_name}</Text>
                    <span className="time">
                      {dayjs(item.start_date).format("ddd; Do MMM YYYY")}
                    </span>
                  </div>
                }
              />
            </AnnouncementItem>
          )}
        />
      </ListWrapper>
    </Wrapper>
  );
};

export default UpcommingHolidayLists;
